module.exports = __webpack_public_path__ + "tr.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/tr.svg
// module id = 1106
// module chunks = 0